module.exports = __webpack_public_path__ + "static/1-6aa41924effbb45c17a51cc128e612bd.jpg";